import type { RelationshipsNode } from '../types';
import { getImageColorFilterValueForModel } from 'views/ConditionalFormattingImageColorFilters';
import { drawImage } from 'tabview/canvasRendering/drawImage';
import { paintImageInCircle } from 'tabview/canvasRendering/paintImageInCircle';

/** calculates an image margin equivalent to our design, which uses 8px margins inside a circle with a diameter of 50. */
const imageMargin = (maximumDimension: number) => maximumDimension * (8 / 50);

const drawNodeImage = (
  context: CanvasRenderingContext2D,
  node: RelationshipsNode,
  href: string,
  x: number,
  y: number,
  radius: number
) => {
  const { modelId, descendantCount, open } = node;
  const isOpenGroup = descendantCount && open;
  /**
   * If conditional formatting is applied, images should be colored accordingly. It does not help to
   * provide the filter url as a css property. Filter effects are not part of images, and only bitmap
   * is drawn. Therefore we temporarily set the `filter` property on the context itself.
   */
  const filterStylePropertyValue = getImageColorFilterValueForModel(modelId);
  if (filterStylePropertyValue) {
    context.filter = filterStylePropertyValue;
  }

  if (isOpenGroup) {
    drawImage(context, href, x - radius, y - radius, 2 * radius);
  } else {
    paintImageInCircle(
      context,
      href,
      x,
      y,
      radius,
      2 * radius - 2 * imageMargin(2 * radius)
    );
  }
  if (filterStylePropertyValue) {
    context.filter = 'none';
  }
};
export { drawNodeImage };
